import React from "react";
import Bredcrumb from "../../HomeMain/Bredcrumb";
import { Link, useParams } from "react-router-dom";

import { useEffect } from "react";
import { useState } from "react";
import { baseURL, kullaniciId } from "../../../App";
import axios from "axios";
import { useGlobalState } from "../../../useGlobalState";


const Main = () => {
  const { url } = useParams();
  const [iletisim, setIletisim] = useState([]);

  const [hizmet, setHizmet] = useState(null);
  const [hizmetler, setHizmetler] = useState(null);

  const { globalState, setGlobalState } = useGlobalState()



  // Tüm hizmetleri çekmek için kullanılan useEffect
  useEffect(() => {
    const getHizmet = async () => {
      try {
        const res = await axios.get(`${baseURL}items/hizmetler?fields=*.*&filter[user_created][_eq]=${kullaniciId}`);
        setHizmetler(res.data.data);
        const hiz = res.data.data.filter(e => e.hizmet_link === "/" + url)[0]
        setHizmet(hiz)

        // Diğer kodlar...
      } catch (error) {
        console.error("Hizmetler getirilirken bir hata oluştu:", error);
      }
    };

    getHizmet();
  }, [url]);



  const fetchContactData = async () => {
    try {
      const response = await axios.get(`${baseURL}items/iletisim?fields=*.*&filter[kullanici][_eq]=${kullaniciId}`);
      // Verinin doğru formatta olup olmadığını kontrol et
      if (response.data) {
        // Veriyi state'e set etme
        setIletisim(response.data.data);
      } else {
        console.error("Invalid data format received from Directus.");
      }
    } catch (error) {
      console.error("Error fetching data from Directus:", error);
    }
  };

  useEffect(() => {
    fetchContactData();
  }, []);



  const [hizmetAyar, setHizmetAyar] = useState([]);

  useEffect(() => {
    try {
      axios
        .get(`${baseURL}items/hizmet_sayfasi_ayarlar?fields=*.*&filter[kullanici][_eq]=${kullaniciId}`)
        .then((response) => {
          setHizmetAyar(response.data.data);
          // console.log(response.data.data, "hizmetsayfasi.data.data");
        })
        .catch((error) => {
          console.error("Error fetching data from Directus:", error);
        });
    } catch (error) {
      console.error("An error occurred in useEffect:", error);
    }
  }, []);


  return (
    hizmet && hizmetler && (
      <>
        {hizmet && hizmet?.translations?.filter(e => e.languages_code === globalState.lang)[0] && (

          <Bredcrumb title={hizmet.translations?.filter(b => b.languages_code === globalState.lang)[0]?.hizmet_baslik}
            subtitle={hizmet.translations?.filter(b => b.languages_code === globalState.lang)[0]?.hizmet_baslik}
            breadcrumb_resim={`${baseURL}assets/${hizmetAyar[0]?.breadcrumb_kapak?.id}`}

          />
        )}

        <div className="about-area5 about-p p-relative">
          <div className="container pt-120 pb-90">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-4 order-1">
                <aside className="sidebar services-sidebar">
                  <div className="sidebar-widget categories">
                    <div className="widget-content">
                      <ul className="services-categories">
                        {hizmetler && hizmetler.map((e) => (
                          <li key={e.id}>
                            <Link
                              to={"/hizmetler" + e?.hizmet_link}
                              className={`${e?.hizmet_link === "/" + url ? "active" : ""}`}
                            >
                              {e?.translations?.filter(b => b.languages_code === globalState.lang)[0]?.hizmet_baslik}
                              <i className="fa fa-arrow-right"></i>
                            </Link>
                          </li>
                        ))}

                      </ul>
                    </div>
                  </div>
                  {iletisim && iletisim[0]?.translations?.filter(e => e.languages_code === globalState.lang)[0] && (
                    <div
                      className="service-detail-contact wow fadeup-animation"
                      data-wow-delay="1.1s"
                    >
                      <h3 className="h3-title">
                        {iletisim && iletisim[0].translations?.filter(e => e.languages_code == globalState.lang)[0]?.iletisim_baslik}
                      </h3> <br />
                      <Link
                        to={iletisim && iletisim[0].translations?.filter(e => e.languages_code === globalState.lang)[0]?.telefon2}
                        target="_blank"
                        title="WhatsApp iletişim"
                      >
                        {iletisim && iletisim[0].translations?.filter(e => e.languages_code == globalState.lang)[0]?.telefon}
                      </Link>
                    </div>
                  )}
                </aside>
              </div>



              <div className="col-lg-8 col-md-12 col-sm-12 order-2">
                <div className="service-detail">
                  {hizmet &&
                    <div className="content-box">
                      <h4>{hizmet.translations?.filter(b => b.languages_code === globalState.lang)[0]?.hizmet_baslik} </h4>
                      <p> {hizmet.translations?.filter(b => b.languages_code === globalState.lang)[0]?.hizmet_sayfa_ilk_baslik}</p>
                      <div className="two-column">
                        <div className="row">
                          <div className="image-column col-xl-6 col-lg-12 col-md-12">
                            <figure className="image">
                              <img src={`${baseURL}assets/${hizmet.resim1?.id}`} alt="" />
                            </figure>
                          </div>
                          <div className="text-column col-xl-6 col-lg-12 col-md-12">
                            <figure className="image">
                              <img src={`${baseURL}assets/${hizmet.hizmet_resim?.id}`} alt="" />
                            </figure>
                          </div>
                        </div>
                      </div>
                      <h4>{hizmet.translations?.filter(b => b.languages_code === globalState.lang)[0]?.hizmet_altbaslik} </h4>
                      <p>
                        {hizmet.translations?.filter(b => b.languages_code === globalState.lang)[0]?.metin}
                      </p>

                      <div className="two-column">
                        <div className="row">
                          <div className="image-column col-xl-12 col-lg-12 col-md-12">
                            <figure className="image">
                              <img src={`${baseURL}assets/${hizmet.hizmet_kucuk_resim?.id}`} alt="" />
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default Main;
